import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { alpha, Box, Divider, Typography } from '@mui/material';
import { forwardRef, memo, useRef } from 'react';
import AdvocateSection from '../../advocate-section';
import Likes from '../../likes';
import AncillaryButton from './ancillary-button';
import { EditCommentProvider, EditField, SaveEditButton } from './edit-comment';
import useDeleteComment from './use-delete-comment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var Comment = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var profileId = _ref.profileId,
      totalFetched = _ref.totalFetched,
      publicResponseId = _ref.publicResponseId,
      _ref$comment = _ref.comment,
      id = _ref$comment.id,
      member = _ref$comment.member,
      createdAt = _ref$comment.createdAt,
      body = _ref$comment.body,
      likes = _ref$comment.likes,
      isNew = _ref.isNew,
      innerSx = _ref.innerSx,
      hiddenFromMembers = _ref.hiddenFromMembers,
      _ref$isFocused = _ref.isFocused,
      isFocused = _ref$isFocused === void 0 ? false : _ref$isFocused;
  var parsedId = id.split('comment_')[1]; //TODO: remove this when the API updates to accept full UUID without needing 'comment_' to be removed

  var ownedByCurrentMember = "member_".concat(profileId) === member.id;
  var deleteComment = useDeleteComment({
    publicResponseId: publicResponseId,
    commentId: parsedId,
    totalFetched: totalFetched
  });
  var editInputRef = useRef(null);
  return /*#__PURE__*/_jsx(EditCommentProvider, {
    id: parsedId,
    value: body,
    children: function children(_ref2) {
      var isEditing = _ref2.isEditing,
          startEditing = _ref2.startEditing;
      return /*#__PURE__*/_jsxs(Box, {
        ref: ref,
        sx: {
          background: function background(t) {
            return isNew || isFocused ? alpha(t.palette.primary.main, 0.1) : t.palette.common.white;
          },
          position: 'relative',
          transition: !isNew && !isFocused ? 'background 0.8s ease' : undefined
        },
        children: [/*#__PURE__*/_jsxs(Box, {
          sx: {
            display: 'flex',
            flexDirection: 'row'
          },
          children: [/*#__PURE__*/_jsx(AdvocateSection, {
            sx: mergeSxProps({
              pt: 2,
              pb: 1,
              mr: 2,
              width: '100%'
            }, innerSx),
            avatarSize: "small",
            member: member,
            timestamp: createdAt,
            hiddenFromMembers: hiddenFromMembers,
            children: /*#__PURE__*/_jsxs(_Fragment, {
              children: [isEditing && ownedByCurrentMember ? /*#__PURE__*/_jsx(EditField, {
                defaultValue: body,
                editInputRef: editInputRef
              }) : /*#__PURE__*/_jsx(Typography, {
                sx: {
                  opacity: hiddenFromMembers ? 0.4 : 1
                },
                children: body
              }), /*#__PURE__*/_jsxs(Box, {
                sx: {
                  display: 'flex',
                  justifyContent: 'space-between',
                  ml: -1,
                  gap: 1,
                  mb: hiddenFromMembers && (!likes || likes.totalCount < 1) ? 1 : 0
                },
                children: [/*#__PURE__*/_jsx(Likes, {
                  likeTargetId: id,
                  hideLikeButton: hiddenFromMembers,
                  likeButtonSx: {
                    minWidth: 0
                  }
                }), isEditing && /*#__PURE__*/_jsx(SaveEditButton, {})]
              })]
            })
          }), !isEditing && ownedByCurrentMember ? /*#__PURE__*/_jsx(AncillaryButton, {
            handleEditMore: function handleEditMore() {
              var _editInputRef$current;

              startEditing();
              editInputRef === null || editInputRef === void 0 ? void 0 : (_editInputRef$current = editInputRef.current) === null || _editInputRef$current === void 0 ? void 0 : _editInputRef$current.focus();
            },
            deleteComment: deleteComment
          }) : null]
        }), /*#__PURE__*/_jsx(Divider, {})]
      });
    }
  });
});
Comment.displayName = 'Comment';
export default /*#__PURE__*/memo(Comment);